/**
 * Analytics configuration and utilities
 * Supports Google Analytics 4 and other tracking providers
 */

export const analyticsConfig = {
    // Google Analytics 4 Measurement ID
    ga4Id: process.env.NEXT_PUBLIC_GA4_ID || '',
    
    // Set to false to disable analytics
    enabled: process.env.NEXT_PUBLIC_ANALYTICS_ENABLED !== 'false',
};

/**
 * Track page views
 */
export function trackPageView(path: string): void {
    if (!analyticsConfig.enabled || !analyticsConfig.ga4Id) {
        return;
    }

    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', analyticsConfig.ga4Id, {
            page_path: path,
        });
    }
}

/**
 * Track custom events
 */
export function trackEvent(
    action: string,
    category?: string,
    label?: string,
    value?: number
): void {
    if (!analyticsConfig.enabled) {
        return;
    }

    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value,
        });
    }
}

/**
 * Track content engagement
 */
export function trackContentEngagement(contentType: string, contentId: string): void {
    trackEvent('content_engagement', 'engagement', `${contentType}_${contentId}`);
}

/**
 * Track newsletter signup
 */
export function trackNewsletterSignup(source: string): void {
    trackEvent('newsletter_signup', 'conversion', source);
}

/**
 * Track trial signup
 */
export function trackTrialSignup(source: string): void {
    trackEvent('trial_signup', 'conversion', source);
}

/**
 * Track CTA clicks
 */
export function trackCTAClick(ctaName: string, location: string): void {
    trackEvent('cta_click', 'engagement', ctaName, undefined);
    trackEvent('cta_location', 'engagement', location);
}

/**
 * Track blog post views
 */
export function trackBlogPostView(slug: string, title: string): void {
    trackEvent('blog_view', 'content', slug);
    
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'view_item', {
            items: [{
                item_id: slug,
                item_name: title,
                item_category: 'blog',
            }],
        });
    }
}

// Extend Window interface for gtag
declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
    }
}

